import {AppBar, Badge, Box, Button, Container, IconButton, Stack, Toolbar, Typography} from "@mui/material";
import {useTheme, withStyles} from "@mui/styles";
import TwitterIcon from '@mui/icons-material/Twitter';
import XDLoadoutLogo from "./components/XDLoadoutLogo";
import {useIsMobileHook} from "./utils";
import MobileMenu from "./MobileMenu";
import InfoIcon from '@mui/icons-material/Info';
import MetaIcon from '@mui/icons-material/AutoGraph';
import PeopleIcon from '@mui/icons-material/People';
import MainBg from './assets/main-bg.png'
import LoginButton from "./LoginButton";
import React, {useEffect, useState} from "react";
import {Link, Outlet} from "react-router-dom";
import ReleaseCountdown from "./components/ReleaseCountdown";
import {Construction, Update} from "@mui/icons-material";
import DesktopMainBannerAds from "./components/ads/DesktopMainBannerAds";
import MobileAnchorAd from "./components/ads/MobileAnchorAd";
import AdBlockMessage from "./components/ads/AdBlockMessage";


const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    pageButton: {
        backgroundColor: 'rgb(0,0,0,0)',

    }
});

const style = withStyles(styles)

const pages = [
    {
        name: "Weapon Builder",
        path: "/builder",
        icon: <Construction/>
    },
    {
        name: "Meta",
        path: "/meta",
        highlight: "HOT",
        icon: <MetaIcon/>
    },
    {
        name: "Profiles",
        path: "/profiles/featured",
        icon: <PeopleIcon/>
    },
    {
        name: "More",
        highlight: "DOT",
        children: [
            {
                name: "Updates",
                path: "/updates",
                highlight: "DOT",
                icon: <Update/>
            },
            {
                name: "About",
                path: "/about",
                icon: <InfoIcon/>
            },
        ]
    }
]

function ExpandingNavItem({page}) {
    const theme = useTheme()
    const [expanded, setExpanded] = useState(false)
    return <Badge key={`page-${page.name}`} badgeContent={page.highlight} invisible={expanded}
                  color="error"
                  variant={page.highlight === 'DOT' ? 'dot' : null}
                  sx={{
                      mr: page.highlight ? '10px' : 0,
                      "& .MuiBadge-badge": {
                          m: '10px 10px 0 0',
                          fontSize: page.highlight === 'DOT' ? null : 11,
                          height: page.highlight === 'DOT' ? null : 15,
                          minWidth: page.highlight === 'DOT' ? null :15
                      }
                  }}>
        <Button variant='text' key={page.name}
                onMouseEnter={() => setExpanded(true)}
                onMouseLeave={() => setExpanded(false)}
                sx={{
                    m: '5px',
                    position: 'relative',
                    background: 'none',
                    color: 'white',
                    transition: 'text-shadow 0.3s ease',
                    '&:hover': {
                        textShadow: '#ffffffcc 0 0 10px',
                        background: 'none'
                    }
                }}>
            {page.name}
            <Stack direction='row' position='absolute' top={0} left='105%' backgroundColor='rgba(0,0,0,0.3)'
                   sx={{transition: 'max-width 0.3s ease'}}
                   borderRadius='15px' width={'auto'} maxWidth={expanded ? '500px' : 0} overflow='clip'>
                {page.children.map(p => //<Typography sx={{...theme.typography.button}} p='6px 10px'>{p.name}</Typography>
                    <Badge key={`page-${p.name}`} badgeContent={p.highlight}  invisible={!expanded}
                           color="error"
                           variant={p.highlight === 'DOT' ? 'dot' : null}
                           sx={{
                               mr: p.highlight ? '10px' : 0,
                               "& .MuiBadge-badge": {
                                   m: '10px 10px 0 0',
                                   fontSize: page.highlight === 'DOT' ? null : 11,
                                   height: page.highlight === 'DOT' ? null : 15,
                                   minWidth: page.highlight === 'DOT' ? null :15
                               }
                           }}>
                        <Link to={p.path}>
                            <Button variant='text' key={p.name}
                                    sx={{
                                        m: '0 5px',
                                        background: 'none',
                                        color: 'white',
                                        transition: 'text-shadow 0.3s ease',
                                        '&:hover': {
                                            textShadow: '#ffffffcc 0 0 10px',
                                            background: 'none'
                                        }
                                    }}>
                                {p.name}
                            </Button>
                        </Link>
                    </Badge>
                )}
            </Stack>
        </Button>
    </Badge>;
}

const MenuBar = () => {
    const isMobile = useIsMobileHook()
    return isMobile ? null :
        <Stack direction='row' sx={{pl: '25px'}}>
            {pages.map((page) =>
                !page.children ?
                    <Badge key={`page-${page.name}`} badgeContent={page.highlight}
                           color="error"
                           sx={{
                               mr: page.highlight ? '10px' : 0,
                               "& .MuiBadge-badge": {
                                   m: '10px 10px 0 0',
                                   fontSize: 11,
                                   height: 15,
                                   minWidth: 15
                               }
                           }}>
                        <Link to={page.path}>
                            <Button variant='text' key={page.name}
                                    sx={{
                                        m: '5px',
                                        background: 'none',
                                        color: 'white',
                                        transition: 'text-shadow 0.3s ease',
                                        '&:hover': {
                                            textShadow: '#ffffffcc 0 0 10px',
                                            background: 'none'
                                        }
                                    }}>
                                {page.name}
                            </Button>
                        </Link>
                    </Badge>
                    :
                    <ExpandingNavItem page={page}/>
            )}
        </Stack>
}

export const MainGradient = 'linear-gradient(170deg, #3c3c40 0%, #1F1F21 80%)';

function App({classes}) {
    const isMobile = useIsMobileHook()
    const [secretCounter, setSecretCounter] = useState(0)
    const [adsBlocked, setAdsBlocked] = useState(false)

    useEffect(() =>
        setTimeout(() => {
            console.log(window.adsbygoogle?.loaded ?? false, isMobile)
            setAdsBlocked((!window.adsbygoogle?.loaded ?? true) && !isMobile)
        }, 2000), [isMobile, setAdsBlocked]
    )

    return (
        <Box sx={{
            backgroundImage: 'linear-gradient(170deg, #3c3c40 0%, #1F1F21 95%)',
            height: '100%',
            minHeight: '100vh'
        }}>
            <Box sx={{
                height: '100%', width: '100%', position: 'absolute', backgroundImage: `url(${MainBg})`,
                backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%',
                overflow: 'auto', '&::-webkit-scrollbar': {display: 'none'}
            }}>
                <Box sx={{flexGrow: 1, paddingBottom: isMobile ? 0 : '10px'}}>
                    <AppBar component='nav' sx={{backgroundColor: '#28282b', overflowY: 'clip'}}>
                        <div style={{position: 'relative'}}>
                            <div style={{
                                position: 'absolute',
                                top: 0, left: 0,
                                backgroundImage: 'linear-gradient(135deg, #3c3c40 10%, #1F1F21 90%, #000000 100%)',
                                clipPath: 'polygon(0% 0%, 100% 0%, calc(100% - 64px) 100%, 0% 100%)',
                                width: isMobile ? '30vw' : '825px',
                                height: '64px',
                            }}/>
                            <div style={{
                                position: 'absolute',
                                top: 0, right: 0,
                                backgroundImage: 'linear-gradient(315deg, #3c3c40 0%, #1F1F21 85%, #000000 100%)',
                                clipPath: 'polygon(64px 0%, 100% 0%, 100% 100%, 0% 100%)',
                                width: isMobile ? '30vw' : '200px',
                                height: '64px',
                            }}/>
                        </div>
                        <Toolbar>
                            <Stack direction='row' alignItems='center' justifyContent='space-between' width='100%'>
                                <Stack direction='row' alignItems='center'>
                                    <MobileMenu navItems={pages}/>
                                    <XDLoadoutLogo height={isMobile ? '32px' : '40px'}/>
                                    <IconButton aria-label="twitter"
                                                onClick={() => window.open('https://twitter.com/XDLoadout')}>
                                        <TwitterIcon sx={{color: 'white', ml: '5px'}}/>
                                    </IconButton>
                                    <MenuBar/>
                                </Stack>
                                <ReleaseCountdown/>
                                <LoginButton/>
                            </Stack>
                        </Toolbar>
                        <AdBlockMessage adsBlocked={adsBlocked}/>
                    </AppBar>
                </Box>
                <Container sx={{p: {xs: '0 10px', md: '0 24px'}, maxWidth: {md: '1350px'}, display: 'relative'}}>
                    <DesktopMainBannerAds/>
                    <Stack>
                        <div className={classes.appBarSpacer}></div>
                        {adsBlocked ? <div style={{height: '25px'}}/> : null}
                        <Stack sx={{minHeight: {xs: '80vh', md: '85vh'}}}>
                            <Outlet/>
                        </Stack>
                        <Typography variant='body2' textAlign='center'
                                    onClick={() => setSecretCounter(secretCounter + 1)}
                                    sx={{padding: '5px 0 0 0', fontStyle: 'oblique', color: 'text.primary'}}>
                            © {new Date().getYear() + 1900} - XDLoadout<br/>
                        </Typography>
                        <Typography sx={{
                            pb: '5px',
                            textAlign: 'center',
                            fontStyle: 'oblique',
                            color: 'text.primary',
                            fontSize: '0.7rem'
                        }}>
                            XDLoadout has no affiliation with XDefiant or Ubisoft
                        </Typography>
                    </Stack>
                    <MobileAnchorAd/>
                </Container>
            </Box>
        </Box>
    )
}

export default style(App)
